export default "__VITE_ASSET__BgPlY6sc__"